import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Iservices } from "../../types/services.type";

export const RegularServiceTable = () => {
  const { services } = useRegularServiceTable();
  return (
    <div className="bg-light md:bg-white">
      <div className="wrapper">
        <div className="mx-auto w-full p-4">
          <div className="overflow-x-auto">
            <table className="table-auto border-collapse min-w-[600px] w-full">
              <caption className="caption-bottom mt-4">
                Service Holding Days: To Check for special event programs{" "}
                <Link className="text-pale-blue" to="/">
                  Click here
                </Link>
                .
              </caption>
              <thead className="font-semibold bg-grey">
                <tr>
                  <th className="px-4 py-3 text-left">DAYS</th>
                  <th className="px-4 py-3 text-left">PROGRAMS</th>
                  <th className="px-4 py-3 text-left">START TIME</th>
                  <th className="px-4 py-3 text-left">CLOSE TIME</th>
                </tr>
              </thead>
              <tbody>
                {services.map((service, index) => {
                  return (
                    <tr key={index} className="even:bg-grey odd:bg-white">
                      <td className="px-4 py-3">{service.day}</td>
                      <td className="px-4 py-3">{service.program}</td>
                      <td className="px-4 py-3">{service.startTime}</td>
                      <td className="px-4 py-3">{service.closeTime}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export const useRegularServiceTable = () => {
  const [services, setServices] = useState<Iservices[]>([
    {
      day: "Sunday",
      program: "EVANGELICAL OUTREACH",
      startTime: "7:00 AM",
      closeTime: "9:00 AM",
    },
    {
      day: "Thursday",
      program: "HOUR OF WORSHIP",
      startTime: "7:30 AM",
      closeTime: "10:00 AM",
    },
    {
      day: "Friday",
      program: "PRAYER WARRIOR",
      startTime: "6:00 AM",
      closeTime: "7:30 AM",
    },
    {
      day: "Last Thursday of the Month",
      program: "BREAKFAST WITH THE KING",
      startTime: "7:30 AM",
      closeTime: "10:00 AM",
    },
  ]);

  return { services, setServices };
};
